import { contextDomainUri } from './constants.ts';
import type { CreateContext } from '../../common/context/types/messages.ts';
import type { RemoteSubscribeContext } from '../../common/context/ops.ts';
import type { PeerId } from '../../state/types/common.ts';
import type { Context, Version } from '../../state/types/context.ts';

export function createContext(requestId: string, peerId: PeerId, name, data, lifetime, readPermissions, writePermissions, version: Version): CreateContext & {version: Version} {
    return {
        domain: contextDomainUri,
        type: 'create-context',
        request_id: requestId,
        peer_id: peerId,
        name,
        data,
        lifetime,
        read_permissions: readPermissions,
        write_permissions: writePermissions,
        version
    };
}

export function subscribe(requestId: string, peerId: PeerId, context: Context): RemoteSubscribeContext {
    return {
        domain: contextDomainUri,
        type: 'subscribe-context',
        peer_id: peerId,
        request_id: requestId,
        context_id: context.id,
        name: context.name
    };
}
